import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import Icon from '@ontruck/ontruck-react-components/lib/Icon';

import { compose } from 'recompose';

const ExtraIcon = styled(Icon)`
  color: var(--greyWolf);
  margin-right: ${(props) => props.theme.base.gridSizes.XS};
`;

ExtraIcon.propTypes = {
  name: PropTypes.string.isRequired,
};

const enhance = compose(injectIntl);

const VehicleExtras = React.memo(({ intl, has_liftgate, has_lateral_loading, ...props }) => {
  return (
    <Fragment>
      {has_liftgate ? <ExtraIcon name="lift-truck" /> : null}
      {has_lateral_loading ? <ExtraIcon name="side-door" /> : null}
    </Fragment>
  );
});

VehicleExtras.propTypes = {
  intl: PropTypes.object.isRequired,
  has_liftgate: PropTypes.bool,
  has_lateral_loading: PropTypes.bool,
};

VehicleExtras.defaultProps = {
  has_lateral_loading: false,
  has_liftgate: false,
};

export default enhance(VehicleExtras);
